export const getSuperbillAnalysesData = state => state.superbillAnalyses.all;
export const getSuperbillAnalysisData = state => state.superbillAnalyses.superbillAnalysis;
export const superbillAnalysesIsFetching = state => state.superbillAnalyses.loading.all;
export const superbillAnalysisIsFetching = state => state.superbillAnalyses.loading.superbillAnalysis;